import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  TableCell,
  TextField,
  NativeSelect,
  Box,
  Typography,
  Tooltip,
  TableHead,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tablecell, order_Type } from "../../../component/Methods";

const RebalancingInfo = ({
  funds,
  deltaRebalancer,
  setDeltaRebalancer,
  deltaValue,
  setDeltaValue,
  driftValue,
  setDriftValue,
  rebalanceType,
}) => {
  const theme = useTheme();

  const [custodianVal, setCustodian] = useState("");
  const [brokerVal, setBroker] = useState("");
  const [postOms, setpostOms] = useState("");
  const [typeVal, setType] = useState("");
  const [pageLimit, setpageLimit] = useState("");
  const [orders, setorders] = useState("");

  const postOms_type = ["TRUE", "FALSE"];

  useEffect(() => {
    if (funds && funds?.length > 0) {
      const fund = funds[0];
      setCustodian(fund.custodianId || "");
      setBroker(fund.brokerId || "");
      setpostOms(fund.postOms || "TRUE");
      setType(fund.orderType || "Limit");
      setpageLimit(fund.pageLimit || "0.40%");
      setorders(fund.orders || "0.5 Basis Points");
    } else {
      setCustodian("");
      setBroker("");
      setpostOms("");
      setType("");
      setpageLimit("");
      setorders("");
    }
  }, [funds]);
  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "4px",
        marginTop: "10px",
        width: "80%",
        marginRight: 1,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Table
        size="small"
        stickyHeader
        aria-label="a dense table"
        sx={{
          height: "50%",
          borderCollapse: "collapse",
          border: `solid 1px ${theme.palette.divider}`,
          marginTop: "-1px",
        }}
      >
        <TableHead>
        <TableRow sx={{ backgroundColor: theme.palette.primary.main }}>
          <TableCell
            colSpan={2}
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              backgroundColor: theme.palette.primary.main,
              textAlign: "left",
              width: "100px",
              color: theme.palette.primary.contrastText,
            }}
          >
            Rebalance Preferences
          </TableCell>
        </TableRow>
</TableHead>
        <TableBody>
          {/* <TableRow>
            <Tablecell align="left" sx={{ paddingLeft: "10px" }}>
              Custodian Preference
            </Tablecell>
            <Tablecell align="left">
              <NativeSelect
                value={custodianVal}
                onChange={(e) => setCustodian(e.target.value)}
                disableUnderline
                sx={{ fontSize: "12px", paddingLeft: "10px" }}
                id="custodian"
                name="custodian"
              >
                <option value="">Select Custodian</option>
                {custodians?.map((val) => (
                  <option key={val.cutodianId} value={val.cutodianId}>
                    {val.abbreviation}
                  </option>
                ))}
              </NativeSelect>
            </Tablecell>
          </TableRow> */}

          {/* <TableRow>
            <Tablecell align="left" sx={{ paddingLeft: "10px" }}>
              Broker Preference
            </Tablecell>
            <Tablecell align="left">
              <NativeSelect
                value={brokerVal}
                onChange={(e) => setBroker(e.target.value)}
                disableUnderline
                sx={{ fontSize: "12px", paddingLeft: "10px" }}
                id="brokerVal"
                name="brokerVal"
              >
                <option value="">Select Broker</option>
                {data?.map((val) => (
                  <option key={val.brokerId} value={val.brokerId}>
                    {val.abbreviation}
                  </option>
                ))}
              </NativeSelect>
            </Tablecell>
          </TableRow> */}

          {rebalanceType === "specific" && (
            <>
              <TableRow>
                <Tablecell 
                  align="left" 
                  sx={{ 
                    paddingLeft: "10px",
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  Drift Rebalancer
                </Tablecell>
                <Tablecell 
                  align="left"
                  sx={{
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  <NativeSelect
                    value={deltaRebalancer}
                    onChange={(e) => setDeltaRebalancer(e.target.value)}
                    disableUnderline
                    sx={{ 
                      fontSize: "11px", 
                      paddingLeft: "10px",
                      color: theme.palette.text.primary,
                      "& .MuiNativeSelect-select": {
                        color: theme.palette.text.primary,
                      },
                    }}
                    id="deltaRebalancer"
                    name="deltaRebalancer"
                  >
                    <option value="1" selected={deltaRebalancer === 1}>
                      True
                    </option>
                    <option value="0" selected={deltaRebalancer === 0}>
                      False
                    </option>
                  </NativeSelect>
                </Tablecell>
              </TableRow>
              <TableRow>
                <Tablecell 
                  align="left" 
                  sx={{ 
                    paddingLeft: "10px",
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    Individual Drift
                    <Tooltip
                      title="Do not rebalance the stock if the difference between signal set and current position for that stock is within this threshold."
                      componentsProps={{
                        tooltip: {
                          sx: {
                            fontSize: "16px",
                            backgroundColor: theme.palette.grey[900],
                            color: theme.palette.common.white,
                            padding: "8px 12px",
                            maxWidth: "300px",
                            lineHeight: "1.4",
                          },
                        },
                      }}
                    >
                      <InfoOutlinedIcon
                        sx={{
                          fontSize: "16px",
                          color: theme.palette.text.secondary,
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </Box>
                </Tablecell>
                <Tablecell 
                  align="left"
                  sx={{
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      type="number"
                      value={deltaValue}
                      onChange={(e) => setDeltaValue(e.target.value)}
                      variant="standard"
                      sx={{
                        fontSize: "11px",
                        width: "60px",
                        "& .MuiInputBase-input": {
                          fontSize: "11px",
                          padding: "0px",
                          paddingLeft: "10px",
                          textAlign: "left",
                          color: theme.palette.text.primary,
                        },
                        "& .MuiInput-underline:before": {
                          borderBottom: "none",
                        },
                        "& .MuiInput-underline:after": { borderBottom: "none" },
                        "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                          {
                            borderBottom: "none",
                          },
                      }}
                      inputProps={{
                        step: "0.01",
                        min: "0",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "12px",
                        ml: 0.2,
                        color: theme.palette.text.secondary,
                      }}
                    >
                      %
                    </Typography>
                  </Box>
                </Tablecell>
              </TableRow>
              <TableRow>
                <Tablecell 
                  align="left" 
                  sx={{ 
                    paddingLeft: "10px",
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    Total Drift
                    <Tooltip
                      title="Acceptable drift between Current Position (Long/Short) and Proposed Positions (Long/Short) after Drift Rebalance."
                      componentsProps={{
                        tooltip: {
                          sx: {
                            fontSize: "16px",
                            backgroundColor: theme.palette.grey[900],
                            color: theme.palette.common.white,
                            padding: "8px 12px",
                            maxWidth: "300px",
                            lineHeight: "1.4",
                          },
                        },
                      }}
                    >
                      <InfoOutlinedIcon
                        sx={{
                          fontSize: "16px",
                          color: theme.palette.text.secondary,
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </Box>
                </Tablecell>
                <Tablecell 
                  align="left"
                  sx={{
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      type="number"
                      value={driftValue}
                      onChange={(e) => setDriftValue(e.target.value)}
                      variant="standard"
                      sx={{
                        fontSize: "12px",
                        width: "60px",
                        "& .MuiInputBase-input": {
                          fontSize: "12px",
                          padding: "0px",
                          paddingLeft: "10px",
                          textAlign: "left",
                          color: theme.palette.text.primary,
                        },
                        "& .MuiInput-underline:before": {
                          borderBottom: "none",
                        },
                        "& .MuiInput-underline:after": { borderBottom: "none" },
                        "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                          {
                            borderBottom: "none",
                          },
                      }}
                      inputProps={{
                        step: "0.01",
                        min: "0",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "12px",
                        ml: 0.2,
                        color: theme.palette.text.secondary,
                      }}
                    >
                      %
                    </Typography>
                  </Box>
                </Tablecell>
              </TableRow>
            </>
          )}
          <TableRow>
            <Tablecell 
              align="left" 
              sx={{ 
                paddingLeft: "10px",
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              Order Type
            </Tablecell>
            <Tablecell 
              align="left"
              sx={{
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              <NativeSelect
                value={typeVal}
                onChange={(e) => setType(e.target.value)}
                disableUnderline
                sx={{ 
                  fontSize: "12px", 
                  paddingLeft: "10px",
                  color: theme.palette.text.primary,
                  "& .MuiNativeSelect-select": {
                    color: theme.palette.text.primary,
                  },
                }}
                id="typeVal"
                name="typeVal"
              >
                <option value="">Select Order Type</option>
                {order_Type?.map((val, index) => (
                  <option key={index} value={val}>
                    {val}
                  </option>
                ))}
              </NativeSelect>
            </Tablecell>
          </TableRow>

          <TableRow>
            <Tablecell 
              align="left" 
              sx={{ 
                paddingLeft: "10px",
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              Slippage Limit %
            </Tablecell>
            <Tablecell 
              align="center"
              sx={{
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              <TextField
                fullWidth
                value={pageLimit}
                onChange={(e) => setpageLimit(e.target.value)}
                size="small"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "12px",
                    fontWeight: "500",
                    paddingLeft: "10px",
                    color: theme.palette.text.primary,
                  },
                }}
              />
            </Tablecell>
          </TableRow>

          <TableRow>
            <Tablecell 
              align="left" 
              sx={{ 
                paddingLeft: "10px",
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              Ignore orders below
            </Tablecell>
            <Tablecell 
              align="center"
              sx={{
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              <TextField
                fullWidth
                value={orders}
                onChange={(e) => setorders(e.target.value)}
                size="small"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "12px",
                    fontWeight: "500",
                    paddingLeft: "10px",
                    color: theme.palette.text.primary,
                  },
                }}
              />
            </Tablecell>
          </TableRow>

          <TableRow>
            <Tablecell 
              align="left" 
              sx={{ 
                paddingLeft: "10px",
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              Post to OMS?
            </Tablecell>
            <Tablecell 
              align="left"
              sx={{
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              <NativeSelect
                value={postOms}
                onChange={(e) => setpostOms(e.target.value)}
                disableUnderline
                sx={{ 
                  fontSize: "12px", 
                  paddingLeft: "10px",
                  color: theme.palette.text.primary,
                  "& .MuiNativeSelect-select": {
                    color: theme.palette.text.primary,
                  },
                }}
                id="postOms"
                name="postOms"
              >
                {postOms_type?.map((val, index) => (
                  <option key={`${val}-${index}`} value={val}>
                    {val == "TRUE" ? "Yes" : "No"}
                  </option>
                ))}
              </NativeSelect>
            </Tablecell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default RebalancingInfo;
